import { OptOut } from "commonAssets/components/Forms/OptOut";
import { createElement } from "commonAssets/js/helpers";
import { modal } from "commonAssets/lib/modal";

/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality.
 */

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    if (claim.deficiency_reason) {
        const escapeHtml = (value) =>
            String(value)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/\"/g, "&quot;")
                .replace(/'/g, "&#039;");

        const reasons = String(claim.deficiency_reason)
            .split(",")
            .map((reason) => reason.trim())
            .filter(Boolean)
            .map((reason) => `<li>${escapeHtml(reason)}</li>`)
            .join("");

        modal(
            "Claim Deficient",
            `<p>Please fix the issues below and resubmit your claim:</p><ul class="mb-0">${reasons}</ul>`
        );
    }

    return claim;
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    // custom code goes here
    return claim;
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    // custom code goes here
    return claim;
}

export class customOptOut extends OptOut {
    claim_contact_information(params) {
        const contactInfoBodyDisplayBool = Boolean(
            params.form_options.exclusion_form.contact_information.body
        )
            ? true
            : false;
        const div = createElement(
            "div",
            {
                class: "bg-light text-dark border rounded p-3 mb-5",
                id: "contact-information",
            },
            [
                createElement(
                    "div",
                    { class: "h3 mb-3 formTitle", id: "contactInfoTitle" },
                    [],
                    params.form_options.exclusion_form.contact_information.title
                ),
                contactInfoBodyDisplayBool
                    ? createElement(
                          "div",
                          { class: "mb-3 formBody", id: "contactInfoBody" },
                          [],
                          params.form_options.exclusion_form.contact_information
                              .body
                      )
                    : ``,
                this.claim_contact_fields(params),
            ]
        );
        return div;
    }
}
